import React, { useEffect, useRef, useState } from 'react'
import { Baseurl } from '../../constants/env'
import { useSelector } from 'react-redux'
import axios from 'axios'
import Formdata from 'form-data'
import Imagecroper from '../common/imagecroper/Imagecroper'

const Userdata = () => {
  const [show,setShow] = useState(false)
  const [data,setData] = useState([])
  const [name,setName] = useState()
  const [email,setEmail] = useState()
  const [mobile,setMobile] = useState()
  const [refresh,setRefresh] = useState(false)
  const [lastname,setLastname] = useState() 
  const [images,setImages] = useState()

  const image = useRef()
  const circleCropperRef = useRef()

 const {userid} = useSelector(state => state.auth)
  const init = async () => {
    let res = await axios.get(`${Baseurl}/getuser?id=${userid}`)
    setData(res?.data)
    setName(res?.data?.firstname)
    setLastname(res?.data?.lastname)
    setEmail(res?.data?.email)
    setMobile(res?.data?.mobile)
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    let params = new Formdata()
     params.append('name',name)
     params.append('email',email)
     params.append('mobile',mobile)
     params.append('image',circleCropperRef.current.files[0])
     
    await axios.patch(`${Baseurl}/getuser?id=${userid}`,params)
    setRefresh(!refresh)
  }
  const handleRemoveImage = () => {
    try{
        image.current.value = null
        image.current.file = null
        setImages(null);
    }catch(err){
      console.log(err); 
    }
  };

  const handleImageChange = (event) => {
    event.preventDefault()
    if (event.target.files && event.target.files[0]) {
      let reader = new FileReader();
      reader.onload = (e) => {
        setImages(e.target.result);
      };
      reader.readAsDataURL(event.target.files[0]);
    }
  }; 
  useEffect(() => {
    init()
  },[refresh])

  return (
    <div class="tab-pane fade show active" id="profile-tab">
    <div class="account-card">
      <div id="profile-view">
      <img style={{width:'55px',height:'55px'}} src={`${Baseurl}/view/imageupload/${data?.img}`} class="img-fluid mb-3 " alt="Failed" />

        <h4>{data?.firstname} {data?.lastname}</h4>
        <p><strong>Email:</strong> {data?.email}</p>
        <p><strong>Phone:</strong> {data?.mobile}</p>
        <button class="btn btn-danger btn-sm" onClick={() => setShow(!show)} >Edit Profile</button>
      </div>
      <div id="edit-profile" className={`form-section mt-4 ${show ? 'd-block' : ''}`}>
        <h5>Edit Profile</h5>
        <form onSubmit={handleSubmit}>
        <div class="mb-3">
            <label class="form-label">Profile Image</label>
            <section>
        <Imagecroper 
          ref={circleCropperRef} 
          circleMode={true}
          lockAspectRatio={true}
        />
      </section>
            {/* <input type="file" ref={image}   className="form-control" placeholder="" accept="image/jpeg, image/png, image/jpg" onChange={handleImageChange}/> */}
            </div>
            {/* {images ? <div style={{ position: 'relative', display: 'inline-block' }}>
              <span className='fs-6 text-white'>Selected Image</span>
              <div>
              <img
            src={images}
            alt="Uploaded"
            style={{ maxWidth: '100px', maxHeight: '200px' }}
          />
          <button
            onClick={() => handleRemoveImage()}
            style={{
              position: 'absolute',
              top: '23px',
              right: '5px',
              border: 'none',
              borderRadius: '50%',
              padding: '2px',
              cursor: 'pointer',
            }}
          >
            X
          </button>
              </div>
            </div> : <></>} */}
          <div class="mb-3">
            <label class="form-label">Firstname</label>
            <input type="text" class="form-control" value={name} onChange={(e) => setName(e.target.value)} />
          </div>
          <div class="mb-3">
            <label class="form-label">Lastname</label>
            <input type="text" class="form-control" value={lastname} onChange={(e) => setLastname(e.target.value)} />
          </div>
          <div class="mb-3">
            <label class="form-label">Email</label>
            <input type="email" class="form-control" value={email} onChange={(e) => setEmail(e.target.value)} />
          </div>
          <div class="mb-3">
            <label class="form-label">Phone</label>
            <input type="text" class="form-control" value={mobile} onChange={(e) => setMobile(e.target.value)} />
          </div>
          <button class="btn btn-danger btn-sm me-2">Save</button>
          <button type="button" class="btn btn-secondary btn-sm" onClick={() => setShow(!show)} >Cancel</button>
        </form>
      </div>
    </div>
  </div>
  )
}

export default Userdata
